/* WARNING: This file is auto-generated . Do not edit manually. */

import { DbaasLogsInputUpdate } from '../models/DbaasLogsInputUpdate';
import { DbaasLogsOutputOpenSearchAliasCreation } from '../models/DbaasLogsOutputOpenSearchAliasCreation';
import { DbaasLogsRolePermissionKibanaCreation } from '../models/DbaasLogsRolePermissionKibanaCreation';
import { DbaasLogsUserChangePasswordCreation } from '../models/DbaasLogsUserChangePasswordCreation';
import { DbaasLogsAlias } from '../models/DbaasLogsAlias';
import { DbaasLogsCluster } from '../models/DbaasLogsCluster';
import { DbaasLogsOutputElasticsearchIndexCreation } from '../models/DbaasLogsOutputElasticsearchIndexCreation';
import { ServicesService } from '../models/ServicesService';
import { DbaasLogsKibanaUpdate } from '../models/DbaasLogsKibanaUpdate';
import { DbaasLogsEngine } from '../models/DbaasLogsEngine';
import { DbaasLogsService } from '../models/DbaasLogsService';
import { DbaasLogsOperation } from '../models/DbaasLogsOperation';
import { DbaasLogsOutputElasticsearchAliasCreation } from '../models/DbaasLogsOutputElasticsearchAliasCreation';
import { DbaasLogsOutputGraylogDashboardCreation } from '../models/DbaasLogsOutputGraylogDashboardCreation';
import { DbaasLogsDashboard } from '../models/DbaasLogsDashboard';
import { DbaasLogsOutputGraylogStreamCreation } from '../models/DbaasLogsOutputGraylogStreamCreation';
import { DbaasLogsOsdCreation } from '../models/DbaasLogsOsdCreation';
import { DbaasLogsInputCreation } from '../models/DbaasLogsInputCreation';
import { DbaasLogsRoleUpdate } from '../models/DbaasLogsRoleUpdate';
import { DbaasLogsHelper } from '../models/DbaasLogsHelper';
import { DbaasLogsOutputOpenSearchAliasStreamCreation } from '../models/DbaasLogsOutputOpenSearchAliasStreamCreation';
import { DbaasLogsMember } from '../models/DbaasLogsMember';
import { DbaasLogsInputAction } from '../models/DbaasLogsInputAction';
import { DbaasLogsRolePermissionDashboardCreation } from '../models/DbaasLogsRolePermissionDashboardCreation';
import { DbaasLogsRolePermissionOsdCreation } from '../models/DbaasLogsRolePermissionOsdCreation';
import { DbaasLogsRoleMemberCreation } from '../models/DbaasLogsRoleMemberCreation';
import { DbaasLogsUpdate } from '../models/DbaasLogsUpdate';
import { DbaasLogsUrl } from '../models/DbaasLogsUrl';
import { DbaasLogsKibana } from '../models/DbaasLogsKibana';
import { DbaasLogsStreamAlertCondition } from '../models/DbaasLogsStreamAlertCondition';
import { DbaasLogsServiceMetric } from '../models/DbaasLogsServiceMetric';
import { DbaasLogsRolePermissionStreamCreation } from '../models/DbaasLogsRolePermissionStreamCreation';
import { DbaasLogsOutputGraylogStreamAlertUpdate } from '../models/DbaasLogsOutputGraylogStreamAlertUpdate';
import { DbaasLogsLogstashConfiguration } from '../models/DbaasLogsLogstashConfiguration';
import { DbaasLogsTestResult } from '../models/DbaasLogsTestResult';
import { DbaasLogsInput } from '../models/DbaasLogsInput';
import { DbaasLogsStream } from '../models/DbaasLogsStream';
import { DbaasLogsOsd } from '../models/DbaasLogsOsd';
import { DbaasLogsRoleMemberUpdate } from '../models/DbaasLogsRoleMemberUpdate';
import { DbaasLogsOutputGraylogDashboardUpdate } from '../models/DbaasLogsOutputGraylogDashboardUpdate';
import { DbaasLogsArchive } from '../models/DbaasLogsArchive';
import { DbaasLogsOutputOpenSearchIndexCreation } from '../models/DbaasLogsOutputOpenSearchIndexCreation';
import { DbaasLogsPermission } from '../models/DbaasLogsPermission';
import { DbaasLogsClusterRetention } from '../models/DbaasLogsClusterRetention';
import { DbaasLogsTemporaryLogsLink } from '../models/DbaasLogsTemporaryLogsLink';
import { DbaasLogsOutputOpenSearchAliasIndexCreation } from '../models/DbaasLogsOutputOpenSearchAliasIndexCreation';
import { DbaasLogsClusterUpdate } from '../models/DbaasLogsClusterUpdate';
import { DbaasLogsRole } from '../models/DbaasLogsRole';
import { DbaasLogsRolePermissionAliasCreation } from '../models/DbaasLogsRolePermissionAliasCreation';
import { DbaasLogsOutputGraylogDashboardDuplicateCreation } from '../models/DbaasLogsOutputGraylogDashboardDuplicateCreation';
import { DbaasLogsOutputGraylogStreamUpdate } from '../models/DbaasLogsOutputGraylogStreamUpdate';
import { DbaasLogsOutputElasticsearchAliasStreamCreation } from '../models/DbaasLogsOutputElasticsearchAliasStreamCreation';
import { DbaasLogsOutputOpenSearchAliasUpdate } from '../models/DbaasLogsOutputOpenSearchAliasUpdate';
import { DbaasLogsOutputOpenSearchIndexUpdate } from '../models/DbaasLogsOutputOpenSearchIndexUpdate';
import { DbaasLogsEncryptionKey } from '../models/DbaasLogsEncryptionKey';
import { DbaasLogsArchiveUrl } from '../models/DbaasLogsArchiveUrl';
import { DbaasLogsStreamRule } from '../models/DbaasLogsStreamRule';
import { DbaasLogsTokenCreation } from '../models/DbaasLogsTokenCreation';
import { DbaasLogsToken } from '../models/DbaasLogsToken';
import { DbaasLogsInputConfigurationFlowggerUpdate } from '../models/DbaasLogsInputConfigurationFlowggerUpdate';
import { DbaasLogsIndex } from '../models/DbaasLogsIndex';
import { DbaasLogsOutputGraylogStreamAlertCreation } from '../models/DbaasLogsOutputGraylogStreamAlertCreation';
import { DbaasLogsOutputElasticsearchIndexUpdate } from '../models/DbaasLogsOutputElasticsearchIndexUpdate';
import { DbaasLogsOutputGraylogStreamRuleCreation } from '../models/DbaasLogsOutputGraylogStreamRuleCreation';
import { DbaasLogsFlowggerConfiguration } from '../models/DbaasLogsFlowggerConfiguration';
import { DbaasLogsInputConfigurationLogstashUpdate } from '../models/DbaasLogsInputConfigurationLogstashUpdate';
import { DbaasLogsRoleCreation } from '../models/DbaasLogsRoleCreation';
import { DbaasLogsRolePermissionIndexCreation } from '../models/DbaasLogsRolePermissionIndexCreation';
import { DbaasLogsKibanaCreation } from '../models/DbaasLogsKibanaCreation';
import { DbaasLogsOutputElasticsearchAliasUpdate } from '../models/DbaasLogsOutputElasticsearchAliasUpdate';
import { DbaasLogsOsdUpdate } from '../models/DbaasLogsOsdUpdate';
import { DbaasLogsOutputElasticsearchAliasIndexCreation } from '../models/DbaasLogsOutputElasticsearchAliasIndexCreation';
import OVHBase from '../ovh';

class DbaasLogsHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** List available services */
  listLogs = (): Promise<string[]> => {
    return this.ovh.request('GET', '/dbaas/logs');
  };

  /** Returns the service object of connected identity. */
  getLogsByServiceName = (serviceName: string): Promise<DbaasLogsService> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}`);
  };

  /** Update the service properties */
  updateLogsByServiceName = (
    serviceName: string,
    body: DbaasLogsUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('PUT', `/dbaas/logs/${serviceName}`, body);
  };

  /** Launch a contact change procedure */
  launchLogsChangeContactByServiceName = (
    serviceName: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/changeContact`, body);
  };

  /** Returns the list of allowed cluster */
  getLogsClusterByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/cluster`);
  };

  /** Returns details of an allowed cluster */
  getLogsClusterByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<DbaasLogsCluster> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/cluster/${clusterId}`);
  };

  /** Update details of an allowed cluster */
  updateLogsClusterByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: DbaasLogsClusterUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('PUT', `/dbaas/logs/${serviceName}/cluster/${clusterId}`, body);
  };

  /** List all the retention ID available for a given cluster */
  listLogsClusterRetentionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/cluster/${clusterId}/retention`);
  };

  /** Returns details of a retention */
  getLogsClusterRetentionByServiceNameAndClusterIdAndRetentionId = (
    clusterId: string,
    retentionId: string,
    serviceName: string
  ): Promise<DbaasLogsClusterRetention> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/cluster/${clusterId}/retention/${retentionId}`
    );
  };

  /** Return the list of registred encryption keys */
  getLogsEncryptionKeyByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/encryptionKey`);
  };

  /** Add a new encryption key */
  addLogsEncryptionKeyByServiceName = (
    serviceName: string,
    body: DbaasLogsEncryptionKey
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/encryptionKey`, body);
  };

  /** Delete the specified encryption key */
  deleteLogsEncryptionKeyByServiceNameAndEncryptionKeyId = (
    encryptionKeyId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/encryptionKey/${encryptionKeyId}`
    );
  };

  /** Return details of an encryption key */
  getLogsEncryptionKeyByServiceNameAndEncryptionKeyId = (
    encryptionKeyId: string,
    serviceName: string
  ): Promise<DbaasLogsEncryptionKey> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/encryptionKey/${encryptionKeyId}`);
  };

  /** Returns the list of registered input attached to the logged user */
  getLogsInputByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/input`);
  };

  /** Register a new input object */
  postLogsInputByServiceName = (
    serviceName: string,
    body: DbaasLogsInputCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/input`, body);
  };

  /** Returns the list of available input engines */
  getLogsInputEngineByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/input/engine`);
  };

  /** Returns details of specified input engine */
  getLogsInputEngineByServiceNameAndEngineId = (
    engineId: string,
    serviceName: string
  ): Promise<DbaasLogsEngine> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/input/engine/${engineId}`);
  };

  /** Return the list of available helpers for the given input engine */
  getLogsInputEngineHelperByServiceNameAndEngineId = (
    engineId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/input/engine/${engineId}/helper`);
  };

  /** Returns details of specified input engine helper */
  getLogsInputEngineHelperByServiceNameAndEngineIdAndHelperId = (
    engineId: string,
    helperId: string,
    serviceName: string
  ): Promise<DbaasLogsHelper> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/input/engine/${engineId}/helper/${helperId}`
    );
  };

  /** Remove the specified input object */
  deleteLogsInputByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('DELETE', `/dbaas/logs/${serviceName}/input/${inputId}`);
  };

  /** Returns details of specified input */
  getLogsInputByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsInput> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/input/${inputId}`);
  };

  /** Update information of specified input object */
  updateLogsInputByServiceNameAndInputId = (
    inputId: string,
    serviceName: string,
    body: DbaasLogsInputUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('PUT', `/dbaas/logs/${serviceName}/input/${inputId}`, body);
  };

  /** Returns actions of specified input */
  getLogsInputActionByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsInputAction[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/input/${inputId}/action`);
  };

  /** Validate configuration of specified input */
  validateLogsInputConfigtestByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/input/${inputId}/configtest`);
  };

  /** Returns the config test operation result */
  getLogsInputConfigtestResultByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsTestResult> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/input/${inputId}/configtest/result`);
  };

  /** Returns the flowgger configuration */
  getLogsInputConfigurationFlowggerByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsFlowggerConfiguration> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/input/${inputId}/configuration/flowgger`
    );
  };

  /** Update the flowgger configuration */
  updateLogsInputConfigurationFlowggerByServiceNameAndInputId = (
    inputId: string,
    serviceName: string,
    body: DbaasLogsInputConfigurationFlowggerUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/input/${inputId}/configuration/flowgger`,
      body
    );
  };

  /** Returns the logstash configuration */
  getLogsInputConfigurationLogstashByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsLogstashConfiguration> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/input/${inputId}/configuration/logstash`
    );
  };

  /** Update the logstash configuration */
  updateLogsInputConfigurationLogstashByServiceNameAndInputId = (
    inputId: string,
    serviceName: string,
    body: DbaasLogsInputConfigurationLogstashUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/input/${inputId}/configuration/logstash`,
      body
    );
  };

  /** Schedule the end of specified input */
  postLogsInputEndByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/input/${inputId}/end`);
  };

  /** Generate a temporary url to retrieve input logs */
  postLogsInputLogsUrlByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsTemporaryLogsLink> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/input/${inputId}/logs/url`);
  };

  /** Schedule the restart of specified input */
  postLogsInputRestartByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/input/${inputId}/restart`);
  };

  /** Schedule the start of specified input */
  postLogsInputStartByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/input/${inputId}/start`);
  };

  /** Returns the list of urls of specified input */
  getLogsInputUrlByServiceNameAndInputId = (
    inputId: string,
    serviceName: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/input/${inputId}/url`);
  };

  /** Returns Metrics credentials */
  getLogsMetricsByServiceName = (serviceName: string): Promise<DbaasLogsServiceMetric> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/metrics`);
  };

  /** Latest operations */
  getLogsOperationByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/operation`);
  };

  /** Returns details of specified operation */
  getLogsOperationByServiceNameAndOperationId = (
    operationId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/operation/${operationId}`);
  };

  /** Returns the list of alias for connected user */
  getLogsOutputElasticsearchAliasByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/elasticsearch/alias`);
  };

  /** Register a new elasticsearch alias */
  postLogsOutputElasticsearchAliasByServiceName = (
    serviceName: string,
    body: DbaasLogsOutputElasticsearchAliasCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/output/elasticsearch/alias`, body);
  };

  /** Remove specified elasticsearch alias */
  deleteLogsOutputElasticsearchAliasByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}`
    );
  };

  /** Returns specified elasticsearch alias */
  getLogsOutputElasticsearchAliasByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<DbaasLogsAlias> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}`
    );
  };

  /** Update specified elasticsearch alias */
  updateLogsOutputElasticsearchAliasByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string,
    body: DbaasLogsOutputElasticsearchAliasUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}`,
      body
    );
  };

  /** Returns the list of Elasticsearch indexes attached to specified Elasticsearch alias */
  getLogsOutputElasticsearchAliasIndexByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}/index`
    );
  };

  /** Attach a elasticsearch index to specified elasticsearch alias */
  postLogsOutputElasticsearchAliasIndexByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string,
    body: DbaasLogsOutputElasticsearchAliasIndexCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}/index`,
      body
    );
  };

  /** Detach a elasticsearch index from specified elasticsearch alias */
  deleteLogsOutputElasticsearchAliasIndexByServiceNameAndAliasIdAndIndexId = (
    aliasId: string,
    indexId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}/index/${indexId}`
    );
  };

  /** Returns the list of Graylog streams attached to specified Elasticsearch alias */
  getLogsOutputElasticsearchAliasStreamByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}/stream`
    );
  };

  /** Attach a graylog stream to specified elasticsearch alias */
  postLogsOutputElasticsearchAliasStreamByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string,
    body: DbaasLogsOutputElasticsearchAliasStreamCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}/stream`,
      body
    );
  };

  /** Detach a graylog stream from specified elasticsearch alias */
  deleteLogsOutputElasticsearchAliasStreamByServiceNameAndAliasIdAndStreamId = (
    aliasId: string,
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}/stream/${streamId}`
    );
  };

  /** Returns the list of urls of specified alias */
  getLogsOutputElasticsearchAliasUrlByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/elasticsearch/alias/${aliasId}/url`
    );
  };

  /** Returns the list of elasticsearch indexes */
  getLogsOutputElasticsearchIndexByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/elasticsearch/index`);
  };

  /** Register a new elasticsearch index */
  postLogsOutputElasticsearchIndexByServiceName = (
    serviceName: string,
    body: DbaasLogsOutputElasticsearchIndexCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/output/elasticsearch/index`, body);
  };

  /** Remove specified elasticsearch index */
  deleteLogsOutputElasticsearchIndexByServiceNameAndIndexId = (
    indexId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/elasticsearch/index/${indexId}`
    );
  };

  /** Returns specified elasticsearch index */
  getLogsOutputElasticsearchIndexByServiceNameAndIndexId = (
    indexId: string,
    serviceName: string
  ): Promise<DbaasLogsIndex> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/elasticsearch/index/${indexId}`
    );
  };

  /** Update specified elasticsearch index */
  updateLogsOutputElasticsearchIndexByServiceNameAndIndexId = (
    indexId: string,
    serviceName: string,
    body: DbaasLogsOutputElasticsearchIndexUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/elasticsearch/index/${indexId}`,
      body
    );
  };

  /** Returns the list of urls of specified index */
  getLogsOutputElasticsearchIndexUrlByServiceNameAndIndexId = (
    indexId: string,
    serviceName: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/elasticsearch/index/${indexId}/url`
    );
  };

  /** Returns the list of Kibana instances */
  getLogsOutputElasticsearchKibanaByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/elasticsearch/kibana`);
  };

  /** Register a new Kibana instance */
  postLogsOutputElasticsearchKibanaByServiceName = (
    serviceName: string,
    body: DbaasLogsKibanaCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/output/elasticsearch/kibana`, body);
  };

  /** Remove specified Kibana instance */
  deleteLogsOutputElasticsearchKibanaByServiceNameAndKibanaId = (
    kibanaId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/elasticsearch/kibana/${kibanaId}`
    );
  };

  /** Returns specified Kibana instance */
  getLogsOutputElasticsearchKibanaByServiceNameAndKibanaId = (
    kibanaId: string,
    serviceName: string
  ): Promise<DbaasLogsKibana> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/elasticsearch/kibana/${kibanaId}`
    );
  };

  /** Update specified Kibana instance */
  updateLogsOutputElasticsearchKibanaByServiceNameAndKibanaId = (
    kibanaId: string,
    serviceName: string,
    body: DbaasLogsKibanaUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/elasticsearch/kibana/${kibanaId}`,
      body
    );
  };

  /** Returns the list of urls of specified Kibana */
  getLogsOutputElasticsearchKibanaUrlByServiceNameAndKibanaId = (
    kibanaId: string,
    serviceName: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/elasticsearch/kibana/${kibanaId}/url`
    );
  };

  /** Returns the list of graylog dashboards */
  getLogsOutputGraylogDashboardByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/graylog/dashboard`);
  };

  /** Register a new graylog dashboard */
  postLogsOutputGraylogDashboardByServiceName = (
    serviceName: string,
    body: DbaasLogsOutputGraylogDashboardCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/output/graylog/dashboard`, body);
  };

  /** Remove specified graylog dashboard */
  deleteLogsOutputGraylogDashboardByServiceNameAndDashboardId = (
    dashboardId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/graylog/dashboard/${dashboardId}`
    );
  };

  /** Returns details of specified graylog dashboard */
  getLogsOutputGraylogDashboardByServiceNameAndDashboardId = (
    dashboardId: string,
    serviceName: string
  ): Promise<DbaasLogsDashboard> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/dashboard/${dashboardId}`
    );
  };

  /** Update information of specified graylog dashboard */
  updateLogsOutputGraylogDashboardByServiceNameAndDashboardId = (
    dashboardId: string,
    serviceName: string,
    body: DbaasLogsOutputGraylogDashboardUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/graylog/dashboard/${dashboardId}`,
      body
    );
  };

  /** Copy all widgets from specified dashboard to a new one */
  postLogsOutputGraylogDashboardDuplicateByServiceNameAndDashboardId = (
    dashboardId: string,
    serviceName: string,
    body: DbaasLogsOutputGraylogDashboardDuplicateCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/output/graylog/dashboard/${dashboardId}/duplicate`,
      body
    );
  };

  /** Returns the list of urls of specified graylog dashboard */
  getLogsOutputGraylogDashboardUrlByServiceNameAndDashboardId = (
    dashboardId: string,
    serviceName: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/dashboard/${dashboardId}/url`
    );
  };

  /** Returns the list of graylog streams */
  getLogsOutputGraylogStreamByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/graylog/stream`);
  };

  /** Register a new graylog stream */
  postLogsOutputGraylogStreamByServiceName = (
    serviceName: string,
    body: DbaasLogsOutputGraylogStreamCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/output/graylog/stream`, body);
  };

  /** Remove specified graylog stream */
  deleteLogsOutputGraylogStreamByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}`
    );
  };

  /** Returns details of specified graylog stream */
  getLogsOutputGraylogStreamByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsStream> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}`);
  };

  /** Update information of specified graylog stream */
  updateLogsOutputGraylogStreamByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string,
    body: DbaasLogsOutputGraylogStreamUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}`,
      body
    );
  };

  /** Returns the list of configured alerts of specified graylog stream */
  getLogsOutputGraylogStreamAlertByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/alert`
    );
  };

  /** Register a new alert on specified graylog stream */
  postLogsOutputGraylogStreamAlertByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string,
    body: DbaasLogsOutputGraylogStreamAlertCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/alert`,
      body
    );
  };

  /** Remove alert from specified graylog stream */
  deleteLogsOutputGraylogStreamAlertByServiceNameAndStreamIdAndAlertId = (
    alertId: string,
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/alert/${alertId}`
    );
  };

  /** Returns details of specified graylog stream alert */
  getLogsOutputGraylogStreamAlertByServiceNameAndStreamIdAndAlertId = (
    alertId: string,
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsStreamAlertCondition> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/alert/${alertId}`
    );
  };

  /** Update alert information of specified graylog stream */
  updateLogsOutputGraylogStreamAlertByServiceNameAndStreamIdAndAlertId = (
    alertId: string,
    serviceName: string,
    streamId: string,
    body: DbaasLogsOutputGraylogStreamAlertUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/alert/${alertId}`,
      body
    );
  };

  /** Returns the list of archives */
  getLogsOutputGraylogStreamArchiveByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/archive`
    );
  };

  /** Returns details of specified archive */
  getLogsOutputGraylogStreamArchiveByServiceNameAndStreamIdAndArchiveId = (
    archiveId: string,
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsArchive> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/archive/${archiveId}`
    );
  };

  /** Get the list of encryption keys used to encrypt the archive */
  getLogsOutputGraylogStreamArchiveEncryptionKeyByServiceNameAndStreamIdAndArchiveId = (
    archiveId: string,
    serviceName: string,
    streamId: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/archive/${archiveId}/encryptionKey`
    );
  };

  /** Get a public temporary URL to access the archive */
  postLogsOutputGraylogStreamArchiveUrlByServiceNameAndStreamIdAndArchiveId = (
    archiveId: string,
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsArchiveUrl> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/archive/${archiveId}/url`
    );
  };

  /** Returns the list of rules of specified graylog stream */
  getLogsOutputGraylogStreamRuleByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/rule`
    );
  };

  /** Register a new rule on specified graylog stream */
  postLogsOutputGraylogStreamRuleByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string,
    body: DbaasLogsOutputGraylogStreamRuleCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/rule`,
      body
    );
  };

  /** Remove specified graylog stream rule */
  deleteLogsOutputGraylogStreamRuleByServiceNameAndStreamIdAndRuleId = (
    ruleId: string,
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/rule/${ruleId}`
    );
  };

  /** Returns details of specified graylog stream rule */
  getLogsOutputGraylogStreamRuleByServiceNameAndStreamIdAndRuleId = (
    ruleId: string,
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsStreamRule> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/rule/${ruleId}`
    );
  };

  /** Returns the list of urls of specified graylog stream */
  getLogsOutputGraylogStreamUrlByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/graylog/stream/${streamId}/url`
    );
  };

  /** Returns the list of alias for connected user */
  getLogsOutputOpensearchAliasByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/opensearch/alias`);
  };

  /** Register a new OpenSearch alias */
  postLogsOutputOpensearchAliasByServiceName = (
    serviceName: string,
    body: DbaasLogsOutputOpenSearchAliasCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/output/opensearch/alias`, body);
  };

  /** Remove specified OpenSearch alias */
  deleteLogsOutputOpensearchAliasByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}`
    );
  };

  /** Returns specified OpenSearch alias */
  getLogsOutputOpensearchAliasByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<DbaasLogsAlias> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}`);
  };

  /** Update specified OpenSearch alias */
  updateLogsOutputOpensearchAliasByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string,
    body: DbaasLogsOutputOpenSearchAliasUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}`,
      body
    );
  };

  /** Returns the list of OpenSearch indexes attached to specified OpenSearch alias */
  getLogsOutputOpensearchAliasIndexByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}/index`
    );
  };

  /** Attach a OpenSearch index to specified OpenSearch alias */
  postLogsOutputOpensearchAliasIndexByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string,
    body: DbaasLogsOutputOpenSearchAliasIndexCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}/index`,
      body
    );
  };

  /** Detach a OpenSearch index from specified OpenSearch alias */
  deleteLogsOutputOpensearchAliasIndexByServiceNameAndAliasIdAndIndexId = (
    aliasId: string,
    indexId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}/index/${indexId}`
    );
  };

  /** Returns the list of Graylog streams attached to specified OpenSearch alias */
  getLogsOutputOpensearchAliasStreamByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}/stream`
    );
  };

  /** Attach a Graylog stream to specified OpenSearch alias */
  postLogsOutputOpensearchAliasStreamByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string,
    body: DbaasLogsOutputOpenSearchAliasStreamCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}/stream`,
      body
    );
  };

  /** Detach a Graylog stream from specified OpenSearch alias */
  deleteLogsOutputOpensearchAliasStreamByServiceNameAndAliasIdAndStreamId = (
    aliasId: string,
    serviceName: string,
    streamId: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}/stream/${streamId}`
    );
  };

  /** Returns the list of urls of specified alias */
  getLogsOutputOpensearchAliasUrlByServiceNameAndAliasId = (
    aliasId: string,
    serviceName: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/opensearch/alias/${aliasId}/url`
    );
  };

  /** Returns the list of OpenSearch indexes */
  getLogsOutputOpensearchIndexByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/opensearch/index`);
  };

  /** Register a new OpenSearch index */
  postLogsOutputOpensearchIndexByServiceName = (
    serviceName: string,
    body: DbaasLogsOutputOpenSearchIndexCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/output/opensearch/index`, body);
  };

  /** Remove specified OpenSearch index */
  deleteLogsOutputOpensearchIndexByServiceNameAndIndexId = (
    indexId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/output/opensearch/index/${indexId}`
    );
  };

  /** Returns specified OpenSearch index */
  getLogsOutputOpensearchIndexByServiceNameAndIndexId = (
    indexId: string,
    serviceName: string
  ): Promise<DbaasLogsIndex> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/opensearch/index/${indexId}`);
  };

  /** Update specified OpenSearch index */
  updateLogsOutputOpensearchIndexByServiceNameAndIndexId = (
    indexId: string,
    serviceName: string,
    body: DbaasLogsOutputOpenSearchIndexUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/opensearch/index/${indexId}`,
      body
    );
  };

  /** Returns the list of urls of specified index */
  getLogsOutputOpensearchIndexUrlByServiceNameAndIndexId = (
    indexId: string,
    serviceName: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/output/opensearch/index/${indexId}/url`
    );
  };

  /** Returns the list of OpenSearch Dashboards instances */
  getLogsOutputOpensearchOsdByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/opensearch/osd`);
  };

  /** Register a new OpenSearch Dashboards instance */
  postLogsOutputOpensearchOsdByServiceName = (
    serviceName: string,
    body: DbaasLogsOsdCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/output/opensearch/osd`, body);
  };

  /** Remove specified OpenSearch Dashboards instance */
  deleteLogsOutputOpensearchOsdByServiceNameAndOsdId = (
    osdId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('DELETE', `/dbaas/logs/${serviceName}/output/opensearch/osd/${osdId}`);
  };

  /** Returns specified OpenSearch Dashboards instance */
  getLogsOutputOpensearchOsdByServiceNameAndOsdId = (
    osdId: string,
    serviceName: string
  ): Promise<DbaasLogsOsd> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/opensearch/osd/${osdId}`);
  };

  /** Update specified OpenSearch Dashboards instance */
  updateLogsOutputOpensearchOsdByServiceNameAndOsdId = (
    osdId: string,
    serviceName: string,
    body: DbaasLogsOsdUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/output/opensearch/osd/${osdId}`,
      body
    );
  };

  /** Returns the list of urls of specified OpenSearch Dashboards */
  getLogsOutputOpensearchOsdUrlByServiceNameAndOsdId = (
    osdId: string,
    serviceName: string
  ): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/output/opensearch/osd/${osdId}/url`);
  };

  /** Returns the list of roles */
  getLogsRoleByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/role`);
  };

  /** Register a new role */
  postLogsRoleByServiceName = (
    serviceName: string,
    body: DbaasLogsRoleCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/role`, body);
  };

  /** Remove specified role */
  deleteLogsRoleByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('DELETE', `/dbaas/logs/${serviceName}/role/${roleId}`);
  };

  /** Returns details of specified role */
  getLogsRoleByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string
  ): Promise<DbaasLogsRole> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/role/${roleId}`);
  };

  /** Update information of specified role */
  updateLogsRoleByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string,
    body: DbaasLogsRoleUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('PUT', `/dbaas/logs/${serviceName}/role/${roleId}`, body);
  };

  /** Returns the member list of specified role */
  getLogsRoleMemberByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/role/${roleId}/member`);
  };

  /** Append user into the member list of specified role */
  postLogsRoleMemberByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string,
    body: DbaasLogsRoleMemberCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/role/${roleId}/member`, body);
  };

  /** Remove user from the member list of specified role */
  deleteLogsRoleMemberByServiceNameAndRoleIdAndUsername = (
    roleId: string,
    serviceName: string,
    username: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/role/${roleId}/member/${username}`
    );
  };

  /** Returns the member metadata */
  getLogsRoleMemberByServiceNameAndRoleIdAndUsername = (
    roleId: string,
    serviceName: string,
    username: string
  ): Promise<DbaasLogsMember> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/role/${roleId}/member/${username}`);
  };

  /** Update the member metadata */
  updateLogsRoleMemberByServiceNameAndRoleIdAndUsername = (
    roleId: string,
    serviceName: string,
    username: string,
    body: DbaasLogsRoleMemberUpdate
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'PUT',
      `/dbaas/logs/${serviceName}/role/${roleId}/member/${username}`,
      body
    );
  };

  /** Returns the list of permissions of specified role */
  getLogsRolePermissionByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/role/${roleId}/permission`);
  };

  /** Append a elasticsearch alias permission to role */
  postLogsRolePermissionAliasByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string,
    body: DbaasLogsRolePermissionAliasCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/role/${roleId}/permission/alias`,
      body
    );
  };

  /** Append a graylog dashboard permission to role */
  postLogsRolePermissionDashboardByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string,
    body: DbaasLogsRolePermissionDashboardCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/role/${roleId}/permission/dashboard`,
      body
    );
  };

  /** Append a elasticsearch index permission to role */
  postLogsRolePermissionIndexByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string,
    body: DbaasLogsRolePermissionIndexCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/role/${roleId}/permission/index`,
      body
    );
  };

  /** Append a kibana permission to role */
  postLogsRolePermissionKibanaByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string,
    body: DbaasLogsRolePermissionKibanaCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/role/${roleId}/permission/kibana`,
      body
    );
  };

  /** Append a OpenSearch Dashboards permission to role */
  postLogsRolePermissionOsdByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string,
    body: DbaasLogsRolePermissionOsdCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/role/${roleId}/permission/osd`,
      body
    );
  };

  /** Append a graylog stream permission to role */
  postLogsRolePermissionStreamByServiceNameAndRoleId = (
    roleId: string,
    serviceName: string,
    body: DbaasLogsRolePermissionStreamCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'POST',
      `/dbaas/logs/${serviceName}/role/${roleId}/permission/stream`,
      body
    );
  };

  /** Remove specified permission */
  deleteLogsRolePermissionByServiceNameAndRoleIdAndPermissionId = (
    permissionId: string,
    roleId: string,
    serviceName: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request(
      'DELETE',
      `/dbaas/logs/${serviceName}/role/${roleId}/permission/${permissionId}`
    );
  };

  /** Returns details of specified permission */
  getLogsRolePermissionByServiceNameAndRoleIdAndPermissionId = (
    permissionId: string,
    roleId: string,
    serviceName: string
  ): Promise<DbaasLogsPermission> => {
    return this.ovh.request(
      'GET',
      `/dbaas/logs/${serviceName}/role/${roleId}/permission/${permissionId}`
    );
  };

  /** Get this object properties */
  getLogsServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/serviceInfos`);
  };

  /** Alter this object properties */
  updateLogsServiceInfosByServiceName = (
    serviceName: string,
    body: ServicesService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/dbaas/logs/${serviceName}/serviceInfos`, body);
  };

  /** Returns the list of service tokens */
  getLogsTokenByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/token`);
  };

  /** Add a new token */
  addLogsTokenByServiceName = (
    serviceName: string,
    body: DbaasLogsTokenCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/token`, body);
  };

  /** Delete the specified token */
  deleteLogsTokenByServiceNameAndTokenId = (
    serviceName: string,
    tokenId: string
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('DELETE', `/dbaas/logs/${serviceName}/token/${tokenId}`);
  };

  /** Returns the specified token */
  getLogsTokenByServiceNameAndTokenId = (
    serviceName: string,
    tokenId: string
  ): Promise<DbaasLogsToken> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/token/${tokenId}`);
  };

  /** Returns platform useful urls */
  getLogsUrlByServiceName = (serviceName: string): Promise<DbaasLogsUrl[]> => {
    return this.ovh.request('GET', `/dbaas/logs/${serviceName}/url`);
  };

  /** Initiate a password change procedure. */
  postLogsUserChangePasswordByServiceName = (
    serviceName: string,
    body: DbaasLogsUserChangePasswordCreation
  ): Promise<DbaasLogsOperation> => {
    return this.ovh.request('POST', `/dbaas/logs/${serviceName}/user/changePassword`, body);
  };
}

export { DbaasLogsHandler };
